/** @jsxImportSource @emotion/react */
import React from 'react'

export const TransValue = ({value}) => {
    return <span>{value}</span>
}

